<template>
  <div class="full-screen" v-bind:style="{ backgroundImage: 'url(' + `${user.data.otherInfo['bg-img']}` + ')'}">
    <div class="home-donations app-bg-gradient">
    <div class="stars-bg"></div>
    <Languages class="languages" v-bind:settings="true"></Languages>
    <!-- <Timer></Timer> -->
    <div class="mosque-name">{{user.data.name}}</div>
    <div class="footer">{{"All Donations are Voluntary , T &amp; C applies" | translate}} </div>
    <!--
      TODO: need to get the images and all
    -->
    <div class="payment-section">
      <div v-if="(terminalNotificationStatus === 'PRESENT_CARD')" style="background-image: url('/static/images/taptopay.png')">
        <div> {{ "Tap to pay on terminal" | translate}}</div>
      </div>
      <div v-if="(terminalNotificationStatus !== 'PRESENT_CARD')"  style="background-image: url('/static/images/enter-pin.png')">
        <div> {{ terminalNotificationStatus | translate}}</div>
      </div>
      <!-- <div v-if="(terminalNotificationStatus === 'PRESENT_CARD')">
        <h3>{{"Touch / Insert or Swipe your card" | translate}}</h3>
      </div>
      <div v-if="(terminalNotificationStatus !== 'PRESENT_CARD')">
        <h3>{{terminalNotificationStatus | translate}}</h3>
      </div>
      {{PSSaleRequestStatus | translate}} -->
    </div>
    </div>
    <!--{{PSSaleRequestStatus}}-->
    <!--PLEASE_WAIT
    //when pin enterd
    PIN_ENTRY
    CONNECTING
    CONNECTION_MADE
    APPROVED
    IDLE

    //card touch made
    RETRYING
    REMOVE_CARD
    CONNECTING
    CONNECTION_MADE
    APPROVED
    IDLE

    //when card error
    PLEASE_WAIT
    CONNECTING
    CONNECTION_MADE
    PROCESSING_ERROR
    CARD_ERROR
    REMOVE_CARD
    CONNECTING
    CONNECTION_MADE
    SIGNATURE_VERIFICATION_PROCESS_COMPLETED
    IDLE

    //swiping first time
    use chip card @ machine
    @terminal
    INSERT CARD
    //when card error process


    // insert card and when error came asks for swipe card not swiping left it...
    after few minutes getting response ---- false
    but machine still waiting for swipe card

    -->
    <!--<h2 v-if="(terminalNotificationStatus !== 'PRESENT_CARD')">
      {{terminalNotificationStatus}}
    </h2>-->

  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import Languages from './Languages'

export default {
  name: 'DonationRequested',
  data () {
    return {
      amount: null,
      donationName: null,
      tid: null
    }
  },
  computed: {
    ...mapGetters([
      'user',
      'token',
      'donationType',
      'donationAmount',
      'PSSaleRequestStatus',
      'terminalNotificationStatus',
      'PSSaleRequestResponse',
      'declineSignatureRequiredTransaction'
    ])
  },
  methods: {
    ...mapActions([
      'changeLoadingStatus',
      'resetPSSaleRequestStatus',
      'updateDonationRequest',
      'declineSignatureVerification'
    ])
  },
  components: {
    Languages
  },
  mounted: function () {
    this.amount = this.donationAmount
    this.donationName = this.donationType
    this.tid = this.$route.params.terminalId
    this.$nextTick(() => {
      // Check wether the user has been already logged in.
      if (!this.token) {
        this.$router.push({path: `/${this.tid}/`})
      } else {
        this.changeLoadingStatus(false)
      }
    })
  },
  watch: {
    terminalNotificationStatus (newValue) {
      console.log(`terminalNotificationStatus` + newValue)
      this.transactionReason = newValue
    },
    PSSaleRequestResponse (newValue) {
      this.updateDonationRequest({...newValue})
    },
    PSSaleRequestStatus (newValue) {
      this.$nextTick(this.resetPSSaleRequestStatus.bind(this))
      this.updateDonationRequest(this.PSSaleRequestResponse)
      if (newValue === true) {
        this.$router.push({path: `/${this.tid}/thanks-giving/${this.donationType}/${this.donationAmount}/${this.PSSaleRequestResponse.id}`})
      } else if (newValue === false) {
        this.changeLoadingStatus(false)
        let status = this.terminalNotificationStatus
        if (status === 'TIMED_OUT') {
          this.$router.push({path: `/${this.tid}/time-out/${this.terminalNotificationStatus}/${this.donationType}/${this.donationAmount}/${this.PSSaleRequestResponse.id}`})
        } else {
          this.$router.push({path: `/${this.tid}/payment-failed/${this.terminalNotificationStatus}/${this.donationType}/${this.donationAmount}/${this.PSSaleRequestResponse.id}`})
        }
      }
    },
    declineSignatureRequiredTransaction (newValue) {
      if (newValue) {
        this.declineSignatureVerification({socket: this.$socket})
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.home-donations {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex-direction: column;
  height: 100vh;
  overflow: hidden;
}
.mosque-name {
  font-size: 40px;
  color: #FFF;
  font-family: "Lato";
  font-weight: bold;
  text-shadow: 1px 1.732px 4px rgba( 0, 0, 0, 0.45 );
  margin-top: 61px;
  margin-bottom: 50px;
  letter-spacing: 2px;
}
.payment-section {
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  width: 460px;
  height: 460px;
}
.payment-section > div {
  width: 100%;
  height: 100%;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  background-repeat: no-repeat;
  background-size: 100% 100%;
}
.payment-section > div > div {
  position: absolute;
  font-size: 26px;
  line-height: 30px;
  color: #880913;
  font-weight: 600;
  letter-spacing: 2px;
  top: 82px;
  left: 65px;
  width: 224px;
  height: 172px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  text-align: center;
}

.full-screen {
  background-position: 50%;
}
@media only screen and (min-width: 2000px) {
  .payment-section {
    width: 50%;
    height: 50vh;
  }
  .payment-section > div {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    background-repeat: no-repeat;
    background-size: 100% 100%;
  }
  .payment-section > div > div {
    font-size: 100px;
    line-height: 100px;
    color: #880913;
    font-weight: 600;
    letter-spacing: 6px;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-wrap: wrap;
    margin-bottom: 35%;
    margin-left: 15%;
    width: 36%;
    line-height: 100px;
    text-align: center;
    position: relative;
  }
  div[dir='rtl'] .payment-section > div > div {
    margin-right: 47%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/donation-requested.vue